import styled from '@emotion/styled';
import { css } from '@emotion/core';

export const DesktopSwipersOuter = styled.div`
  height: auto;
  visibility: visible;

  ${({ isDrawingEnabled }) =>
    isDrawingEnabled &&
    `
    height: 0;
    visibility: hidden;
  `}

  ${({ theme }) => theme.breakpoints.md.down} {
    display: none;
  }
`;

export const SmallMultiplesTitle = styled.h4`
  font-family: ${({ theme }) => theme.fonts.sans};
  font-size: 16px;
  margin: 0 0 8px;
`;

export const SmallMultiplesWrapper = styled.div`
  --swiper-theme-color: ${({ theme }) => theme.colors.black};
  padding-bottom: 2px;
  display: none;
  position: relative;

  ${({ theme }) => theme.breakpoints.md.up} {
    display: block;
  }
`;

export const slide = (theme) => css`
  cursor: pointer;
  margin: 0;
  width: 100%;
  padding: 10px 5px;
  transition: opacity ${theme.transitions.hover};

  &:hover {
    opacity: 0.8;
  }
`;

export const SlideMap = styled.img`
  margin: 6px auto 2px;
  padding: 0 10px;
  box-sizing: border-box;
  width: 100%;
  height: auto;
  display: block;
  max-width: 110px;
`;

export const SlideLabel = styled.span`
  padding: 0 5px;
  hyphens: auto; /* disable after manually adding &shy; */
  box-sizing: border-box;
  font-size: 13px;
  line-height: 18px;
  height: 36px;
  width: 100%;
  display: flex;
  justify-content: center;
  /* src https://developer.mozilla.org/en-US/docs/Web/CSS/-webkit-line-clamp; */
  display: -webkit-box;
  align-items: center;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const sharedButtonStyles = css`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  margin: 0;
  width: 2.5em;
  height: 2.5em;
  padding: 0.75em;
  border-radius: 50%;
  line-height: 1;
`;

export const prevButton = css`
  ${sharedButtonStyles}
  left: -1.25em;
`;

export const nextButton = css`
  ${sharedButtonStyles}
  right: -1.25em;
`;

export const MainSwiperWrapper = styled.div`
  position: relative;
  margin-top: var(--margin-vertical-lg, 8px);
  ${({ theme }) => theme.breakpoints.vertical.lg.up} {
    max-width: 480px;
  }
`;

export const IndicatorTitle = styled.h5`
  line-height: 1.25;
  margin: 24px 0 2px;
  text-align: left;
  padding: 0;
  font-size: 18px;
  ${({ theme }) => theme.breakpoints.combined.md.up} {
    font-size: 22px;
  }
`;

export const IndicatorLabel = styled.h6`
  font-size: 16px;
  line-height: 1.25;
  margin: 0 0 16px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.grey60};
`;

export const IndicatorSource = styled.aside`
  font-size: 14px;
  line-height: 1.25;
  margin: 12px 0 12px;
  color: ${({ theme }) => theme.colors.grey60};
`;

export const IndicatorText = styled.p`
  font-family: ${({ theme }) => theme.fonts.serif};
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.black};
  margin: 4px 0 12px;
  padding: 0 36px 0 0;
  font-size: 14px;
  hyphens: auto;

  ${({ theme }) => theme.breakpoints.combined.md.up} {
    font-size: 16px;
  }
`;

const sharedPlainButtonStyles = ({ theme }) => css`
  ${theme.snippets.resetButton};

  svg {
    width: 13px;
    height: 29px;
  }

  position: absolute;
  top: 0;
  bottom: 0;
  height: 90%;
  width: 30%;
  z-index: 99;
  outline: none !important;
`;

export const PlainNextButton = styled.button`
  ${sharedPlainButtonStyles}
  text-align: right;
  padding: 9px 6px 6px 12px;
  right: -15px;
  transition: right 250ms ease-in-out;

  &:hover {
    right: -25px;
  }
`;

export const PlainPrevButton = styled.button`
  ${sharedPlainButtonStyles}
  text-align: left;
  padding: 9px 12px 6px 6px;

  left: -25px;
  transition: left 250ms ease-in-out, opacity 125ms 125ms linear;
  opacity: 0;
  &:hover {
    opacity: 1;
    left: -35px;
  }
`;
